// src/pages/EmployerDashboard.jsx
export default function EmployerDashboard() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Employee Dashboard</h1>
      <p>Welcome! You can view your tasks and submit reports here.</p>
    </div>
  );
}
